import { storage } from '../firestore';
import { getByAttr } from './ListExtensions';

let gsReference = '';

let images= [];

/*TODO What if user access is not longer valid -> do download url expire?*/
export async function getDownloadURL(filePath){
    return new Promise((resolve, reject) => {
        var image = getByAttr(images, 'filePath', filePath)

        if(image == undefined){
            var storageRef = storage.ref(filePath);

            storageRef.getDownloadURL().then(function(url) {
                images.push({filePath: filePath, downloadUrl: url})
                resolve (url)
            }).catch(function(error) {
            // Handle any errors
            });

        }
        else resolve(image.downloadUrl);
    });

}